

















































































import { useMachine } from "@xstate/vue";
import { computed, defineComponent, ref, watch } from "@vue/composition-api";

import { Match } from "@/types";
import store from "@/store/root";
import { machine } from "@/utils/textraction";
import PdfForm from "@/components/PdfForm.vue";
import AuthPanel from "@/components/AuthPanel.vue";
import ModeButton from "@/components/ModeButton.vue";
import CodeDetails from "@/components/CodeDetails.vue";
import ComputedTime from "@/components/ComputedTime.vue";
import DocumentForm from "@/components/DocumentForm.vue";
import EvidencesManager from "@/components/EvidencesManager.vue";
import DocumentDropdown from "@/components/DocumentDropdown.vue";
import DocumentEvidences from "@/components/DocumentEvidences.vue";
import StatusIndicator from "@/components/StatusIndicator.vue";

export default defineComponent({
  components: {
    StatusIndicator,
    PdfForm,
    AuthPanel,
    ModeButton,
    CodeDetails,
    ComputedTime,
    DocumentForm,
    DocumentDropdown,
    DocumentEvidences,
    EvidencesManager
  },
  setup() {
    const term = ref("");

    const input = ref<"pdf" | "text">("text");

    const loading = ref(false);

    const selected = ref<[number, number] | null>(null);

    const document = computed(() => store.state.text);

    const clear = () => {
      term.value = "";
      selected.value = null;
    };

    const onEvidenceSelected = (match: Match) => {
      if (match) {
        term.value = "";
        selected.value = match.concept.text.tokpos;
        term.value = document.value
          .slice(...match.concept.text.charpos)
          .replace("\n", " ");
      }
    };

    const textraction = useMachine(machine);

    const encode = (value: string) => {
      loading.value = true;

      Promise.resolve(value)
        .then(() => store.dispatch("updateRaw", value))
        .then(() => store.dispatch("evidences/update"))
        .finally(() => (loading.value = false));
    };

    const reset = () => {
      store.dispatch("clear");
      textraction.send("RESET");
    };

    watch(
      () => input.value,
      () => {
        reset();
      }
    );

    return {
      term,
      input,
      selected,
      document,
      textraction,
      encode,
      reset,
      clear,
      onEvidenceSelected
    };
  }
});
